'use strict';

module.exports = root;

var all = require('../all');
var wrap = require('../wrap');

function root(h, node) {
  var children = all(h, node);

  if (h.document || wrap.needed(children)) {
    children = wrap(children);
  }

  return h(node, 'root', children);
}



//////////////////
// WEBPACK FOOTER
// ../node_modules/hast-util-to-mdast/handlers/root.js
// module id = 1015
// module chunks = 0